import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  untracked,
} from '@angular/core';

import { createProviderToken } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { ReportDashboardUnavailabilityReason } from '@core/reports-types';
import {
  EmptyStateComponent,
  IconName,
  ResizeObserverEntryDirective,
} from '@core/user-interface-legacy';

export enum PresentionalFailedEmptyStateReason {
  TimeBasedFormInvalid = 'time_based_form_invalid',
  MisconfiguredComponent = 'misconfigured_component',
}

export type ReportsEmptyStateConfig = {
  icon: IconName;
  title: string;
  desc: string;
};

export type ReportsEmptyStateHandler = (
  reason: ReportDashboardUnavailabilityReason | PresentionalFailedEmptyStateReason,
) => ReportsEmptyStateConfig | null;

const { provide, inject } = createProviderToken<ReportsEmptyStateHandler>(
  'ReportsEmptyStateHandler',
)();

export const provideReportsEmptyState = provide;

@Component({
  selector: 'reports-failed-empty-state',
  templateUrl: './failed-empty-state.component.html',
  styleUrls: ['./failed-empty-state.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.standalone]': 'standalone()',
  },
  imports: [EmptyStateComponent, ResizeObserverEntryDirective, TranslatePipe],
})
export class ReportFailedEmptyStateComponent {
  private readonly handler = inject();

  public reason = input.required<
    ReportDashboardUnavailabilityReason | PresentionalFailedEmptyStateReason | null
  >();
  public small = input<boolean>();
  public standalone = input<boolean>();
  public allowRefreshing = input<boolean>();

  public emptyStateConfig = computed(() => {
    const reason = this.reason();
    if (!reason) {
      return null;
    }
    return untracked(() => this.handler(reason));
  });

  public refresh = output<void>();
}
